import { render, staticRenderFns } from "./footerComponent.vue?vue&type=template&id=b9d4f8ca&scoped=true&"
import script from "./footerComponent.vue?vue&type=script&lang=js&"
export * from "./footerComponent.vue?vue&type=script&lang=js&"
import style0 from "./footerComponent.vue?vue&type=style&index=0&id=b9d4f8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d4f8ca",
  null
  
)

export default component.exports